module.exports = __webpack_public_path__ + "img/hexclad-logo.52917621.png";